import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

import pythonImg from "../assets/skills/python.png";
import htmlImg from "../assets/skills/html.png";
import cssImg from "../assets/skills/css3.png";
import JsImg from "../assets/skills/JavaScript.png";
import NodeImg from "../assets/skills/node.png";
import boot from "../assets/skills/boot.jpeg";
import git from "../assets/skills/git.png";
import keras from "../assets/skills/keras.png";
import numpy from "../assets/skills/numpy.png";
import pandas from "../assets/skills/pandas.png";
import postman from "../assets/skills/postman.png";
import pytorch from "../assets/skills/pytorch.png";
import reactImg from "../assets/skills/react.png";
import scikit from "../assets/skills/scikit.jpeg";
import swiftImg from "../assets/skills/swift.png";
import opencv from "../assets/skills/opencv.png";

import java from "../assets/skills/java.png";
import spring from "../assets/skills/spring.png";
import hibernate from "../assets/skills/hibernate.png";
import apache from "../assets/skills/apache.png";
import maven from "../assets/skills/maven.png";
import spark from "../assets/skills/spark.png";
import docker from "../assets/skills/docker.png";
import graphql from "../assets/skills/garphql.png";
import hasura from "../assets/skills/hasura.png";
import kuber from "../assets/skills/kuber.png";
import quarkus from "../assets/skills/quarkus.jpeg";
import swagger from "../assets/skills/swagger.png";

import mysql from "../assets/skills/mysql.png";
import cassandra from "../assets/skills/cassandra.png";
import oracle from "../assets/skills/oracle.png";
import postgre from "../assets/skills/postgresql.png";
import redis from "../assets/skills/redis.png";
import elastic from "../assets/skills/elastic.png";
import mongodb from "../assets/skills/mongodb.png";

import sonar from "../assets/skills/sonar.png";
import kibana from "../assets/skills/kibana.png";
import splunk from "../assets/skills/splunk.png";
import promo from "../assets/skills/promo.png";
import grafa from "../assets/skills/grafa.png";




export const Skills = () => {
    const imagePaths = [
        { img: pythonImg, text: 'Python' },
        { img: htmlImg, text: 'HTML5' },
        { img: cssImg, text: 'CSS3' },
        { img: JsImg, text: 'JavaScript' },
        { img: reactImg, text: 'React' },
        { img: boot, text: 'Bootstrap' },

        { img: java, text: 'Java'},
        { img: spring, text: 'Spring'},
        { img: hibernate, text: 'Hibernate'},
        { img: apache, text: 'Apache Kafka'},
        { img: maven, text: 'Apache Maven'},
        { img: spark, text: 'Apache Spark'},
        { img: docker, text: 'Docker'},
        { img: graphql, text: 'GRAPHQL'},
        { img: hasura, text: 'Hasura'},
        { img: kuber, text: 'Kubernetes'},
        { img: quarkus, text: 'Quarkus'},
        { img: swagger, text: 'Swagger'},

        { img: mysql, text: 'MYSQL'},
        { img: cassandra, text: 'Cassandra'},
        { img: oracle, text: 'Oracle'},
        { img: postgre, text: 'POSTGRESQL'},
        { img: redis, text: 'Redis'},
        { img: elastic, text: 'Elastic Search'},
        { img: mongodb, text: 'MongoDB'},

        { img: sonar, text: 'Sonarqube'},
        { img: kibana, text: 'Kibana'},
        { img: splunk, text: 'Splunk'},
        { img: promo, text: 'Prometheus'},
        { img: grafa, text: 'Grafana'},

        
        { img: git, text: 'Git' },
        { img: keras, text: 'Keras' },
        { img: numpy, text: 'Numpy' },
        { img: pandas, text: 'Pandas' },
        { img: postman, text: 'Postman' },
        { img: pytorch, text: 'Pytorch' },  
        { img: scikit, text: 'scikit learn' },
        { img: opencv, text: 'Open CV' }


       
      ];

      const images = imagePaths.map((skill, index) => (
        <div className="image-container" key={index}>
            <img src={skill.img} alt={skill.text} />
            <span className="hover-text">{skill.text}</span>
        </div>
      ));
      
    
      
  return (
    <section id='skills'>
        <h1 className='header-skillset'>Technology Stack</h1>
        <div className='div-skillset'>
                <AliceCarousel
                        touchTracking={true}
                        mouseTracking={true}
                        items={images}
                        disableDotsControls={true}
                        disableButtonsControls={true}
                        autoPlayInterval={1000}
                        autoPlayDirection="ltr"
                        autoPlay={true}
                        infinite={true} // Enables infinite looping
                        fadeOutAnimation={true}
                        mouseTrackingEnabled={true}
                        responsive={{
                            0: { items: 4},
                            768:{ items: 6},
                            1024: { items: 9}
                        }}
                    />
        </div>
        

    </section>
    
  )
}

